// pcp swatch ix
document.addEventListener('DOMContentLoaded', (event) => {
  if(window.innerWidth < 768){
    let items  = document.querySelectorAll('.grid__item');

    items.forEach(function(item){
      let swatch_containers = item.querySelectorAll('.swatch-wrapper .swatch-container');

      swatch_containers.forEach(function(swatch_container, i){
        if(i > 4 && !swatch_container.classList.contains('more')){
          swatch_container.classList.add('hidden');
        }
      });
    });
  }

  let swatches = document.querySelectorAll('.swatch-wrapper .swatch-container .swatch-bubble');

  swatches.forEach(function(swatch){
    if(!swatch.classList.contains('more')){
      swatch.addEventListener('click', function(e){
        swatches.forEach(function(swatch){
          swatch.classList.remove('selected');
        });
        e.target.classList.add('selected');

        let parent = e.target.closest('.grid__item');

        let img = parent.querySelector('.media img');
        let card_url = parent.querySelector('.card__heading.h5 a');
        let variant_img_url = e.target.dataset.variantImage
        let variant_url = e.target.dataset.variantUrl

        img.srcset = '';
        img.src = variant_img_url;
        card_url.href = variant_url;
      });
    } else {
      swatch.addEventListener('click', function(e){
        let parent = e.target.closest('.grid__item');
        let swatch_containers = parent.querySelectorAll('.swatch-wrapper .swatch-container');

        swatch_containers.forEach(function(swatch_container){
          swatch_container.classList.remove('hidden');
        });

        e.target.closest('.swatch-container').classList.add('hidden');
      });
    }
  });
});